import React, { useState } from "react";
import axios from "axios";
import signupImage from "../assets/signup.png";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const API_BASE_URL = process.env.REACT_APP_NODE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;


const SignUp = () => {

  const navigate = useNavigate(); 
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/register`,
        {
          email: formData.email,
          password: formData.password,
        }
      );
      console.log(response.data.userId);
      alert("user registered!");
      localStorage.setItem("userId", response.data.userId);
      navigate("/sign-in");
    } catch (error) {
      console.error("Registration error:", error.response.data);
      alert(error.response.data.error);

    }
  };

  return (
    <div className="flex h-screen bg-white">
      {/* Left side - Image with gradient background */}
      <div className="flex-1 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white to-[#ff5733] rounded-full transform scale-[2.5] translate-x-1/3 -translate-y-1/4"></div>
        <div className="relative z-10 flex flex-col justify-center items-center h-full p-8">
          <img
            src={signupImage}
            alt="Security and privacy illustration"
            className="max-w-[80%] h-auto"
          />
        </div>
      </div>

      {/* Right side - Form */}
      <div className="flex-1 flex flex-col justify-center p-8">
        <div className="text-center mb-8">
          <img
            src={logo}
            alt="Legaily logo"
            className="max-w-[150px] h-20 mx-auto"
          />
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="block mb-2 font-bold">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              required
              className="w-full p-2 border border-gray-300 rounded"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="block mb-2 font-bold">
              Password
            </label>
            <div className="relative">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                required
                className="w-full p-2 border border-gray-300 rounded"
                value={formData.password}
                onChange={handleChange}
              />
              <button
                type="button"
                className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white hover:bg-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5 text-gray-500"
                >
                  <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
                  <path
                    fillRule="evenodd"
                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="mb-4">
            <label htmlFor="confirmPassword" className="block mb-2 font-bold">
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Confirm Password"
              required
              className="w-full p-2 border border-gray-300 rounded"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-[#ff5733] text-white rounded hover:bg-[#e64d2e] transition duration-300"
          >
            Signup
          </button>
          <div className="mt-4">
            <button
              type="button"
              className="w-full py-3 bg-white border border-gray-300 rounded flex items-center justify-center hover:bg-gray-50 transition duration-300"
            >
              <svg
                className="w-5 h-5 mr-2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  fill="#4285F4"
                />
                <path
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  fill="#34A853"
                />
                <path
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  fill="#FBBC05"
                />
                <path
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  fill="#EA4335"
                />
                <path d="M1 1h22v22H1z" fill="none" />
              </svg>
              Sign up with Google
            </button>
          </div>
          <div className="text-center mt-4">
            Already have an account?{" "}
            <a href="/sign-in" className="text-[#ff5733] hover:underline">
              Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
